(() => {
  const initArticle = (root) => {
    if (!root || root.dataset.tocReady === 'true') return;

    const body = root.querySelector('.ebmini-editorial__body');
    const list = root.querySelector('.ebmini-editorial__toc-list');
    const toc = root.querySelector('.ebmini-editorial__toc');
    if (!body || !list || !toc) return;

    const headings = [...body.querySelectorAll('h2, h3')];
    if (!headings.length) {
      toc.hidden = true;
      root.dataset.tocReady = 'true';
      return;
    }

    const used = new Set();
    headings.forEach((heading, index) => {
      let slug = heading.textContent
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '') || `section-${index + 1}`;
      const base = slug;
      let suffix = 2;
      while (used.has(slug) || document.getElementById(slug)) {
        slug = `${base}-${suffix++}`;
      }
      used.add(slug);
      heading.id = slug;

      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${slug}`;
      link.dataset.level = heading.tagName.slice(1);
      link.textContent = heading.textContent.trim();
      item.appendChild(link);
      list.appendChild(item);
    });

    const links = [...list.querySelectorAll('a')];
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
        if (!visible) return;
        links.forEach((link) => {
          link.classList.toggle('is-active', link.hash === `#${visible.target.id}`);
        });
      },
      { rootMargin: '-18% 0px -68% 0px', threshold: 0 }
    );
    headings.forEach((heading) => observer.observe(heading));
    root.dataset.tocReady = 'true';
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('.ebmini-editorial').forEach(initArticle);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
